export class CreatePassOrderItemDto {
  passId: string;
  quantity: number;
}
